import { useMutation } from "@tanstack/react-query";
import {
  type CreateMerchantRequest,
  type MerchantDetailDto,
  postMerchants,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (publicID: string) => void;
  onError?: () => void;
};

export const useCreateMerchantMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateMerchantRequest) => postMerchants(data),
    ),
    onSuccess: ({ publicID }: MerchantDetailDto) => {
      onSuccess?.(publicID);
    },
    onError,
  });
